import axios from "axios";
import auth from './authentication';
import appConfig from '../../config/config';

const http = axios.create({
  baseURL: appConfig.serverUrlGateway,
  withCredentials: true,
});

http.interceptors.request.use(config => {
  if (auth.isAuthenticated()) {
    config.headers.Authorization = `Bearer ${auth.getToken()}`;
  }

  return config;
});

http.interceptors.response.use(response => response, error => {
  if (error.response && error.response.status === 401) {
    auth.clear();
    window.location.assign('/');
  }
  return Promise.reject(error);
})

export default http;